const state = () => ({
  logs: [],
});

const getters = {
  getClearLogs: (state) => state.logs,
};

const mutations = {
  addLog(state, log) {
    state.logs.push(log);
  },
  empty(state) {
    state.logs = [];
  },
};

const actions = {
  addLog({ commit, rootGetters }, log) {
    if (typeof log.content_key === "object") {
      log.content_key = parseKey(log.content_key);
    }

    log.total_learning_count = rootGetters["learningState/getTotalLearningCount"];
    log.total_clear_count = rootGetters["learningState/getTotalClearCount"];

    log.cleared_at = (new Date()).toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });

    commit("addLog", log);
  },
};

function parseKey(content) {
  const blockMap = {
    "normal": {
      "table2": 1,
      "table3": 2,
      "table4": 3,
      "table5": 4,
      "table6": 5,
      "table7": 6,
      "table8": 7,
      "table9": 8,
      "table2to3": 9,
      "table2to4": 10,
      "table2to5": 11,
      "table2to6": 12,
      "table2to7": 13,
      "table2to8": 14,
      "table2to9": 15,
    },
    "bonus": {
      "table6and7": 1,
      "table7and8": 2,
      "table8and9": 3,
      "table6and9": 4,
      "table4and7": 5,
      "table6to8": 6,
      "table7to9": 7,
      "table2to5": 8,
      "table6to9": 9,
      "table2to9": 10,
    }
  };
  const stageNo = (content.stage === "normal") ? "1" : "2";
  const blockNo = blockMap[content.stage][content.table] ?? 0;
  const levelNo = parseInt(content.level.slice(-1)) || 0;

  return `8-${stageNo}-${blockNo}-${levelNo}-1`;
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
